appHost.actions.register({
    // #region Vars
    name: '288a.identity.user.setpassword',
    // #endregion
    // #region Entry
    async execute(data, params) {
        return this.Window(await appHost.notification.showModal2("g-account-userpassword_change", params));
    },
    // #endregion
});
export {};
